import Vue from 'vue'
import {Input, Popover, Icon, Modal, Checkbox, Popconfirm} from 'ant-design-vue'

// 按需引用：在这里引用你需要用到的ant design vue的组件
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Popover)
Vue.use(Icon)
Vue.use(Modal)
Vue.use(Popconfirm)



// WEBPACK FOOTER //
// ./src/index.js